export type UsageGroupBy =
  | "user"
  | "model"
  | "workspace"
  | "entity"
  | "certification"
  | "question_list";

export enum UsageSource {
  EVALUATION = 0,
  CHAT = 1,
  COMO_VOICES = 2,
  DOCUMENT_CRAFTING = 3,
}

export interface UsageRow {
  user_id?: number | null;
  user_email?: string | null;
  workspace_id?: number | null;
  workspace?: string | null;
  entity_id?: number | null;
  entity?: string | null;
  certification_category_id?: number | null;
  certification?: string | null;
  question_list_id?: number | null;
  question_list?: string | null;
  model_id?: number;
  model?: string;
  input_tokens: number;
  cached_input_tokens: number;
  output_tokens: number;
  reasoning_tokens: number;
  tokens_total: number;
  cost_total: number;
  input_cost?: number;
  cached_input_cost?: number;
  output_cost?: number;
  reasoning_cost?: number;
  tool_calls: number;
  iterations: number;
}

export interface UsageQueryParams {
  from?: string;
  to?: string;
  group_by?: UsageGroupBy;
  user_id?: number;
  email?: string;
  workspace_id?: number;
  entity_id?: number;
  certification_category_id?: number;
  question_list_id?: number;
  source?: UsageSource;
}
